import { useEffect } from "react";

/**
 * What a browser tab and the history list show: the view, the Vorgang when
 * there is one, the app — „Planung · 2026-0001 — Werkbank K60". Every tab
 * used to read „KI-Werkbank Hausprojekte — K60", so a salesperson with five
 * Vorgänge open read the same words five times (GAP-03, UX ruling 12 / F-7).
 */
/** The bare app name — what the tab reads with no view attached to it. */
export const APP_TITLE = "Werkbank K60";

export function documentTitle(label: string, detail?: string | null): string {
  return `${detail ? `${label} · ${detail}` : label} — ${APP_TITLE}`;
}

/** Sets the title for as long as the calling view is on screen, and again
 * whenever the detail arrives or changes. `null` while there is nothing to
 * name yet (a record still loading) leaves the title alone. Leaving the view
 * gives the previous title back — the app name, when the view was the only
 * one naming the tab — so a later view that forgets this hook does not keep
 * showing the previous Vorgang's number. */
export function useDocumentTitle(label: string | null, detail?: string | null): void {
  useEffect(() => {
    if (label === null) return undefined;
    const before = document.title;
    document.title = documentTitle(label, detail);
    return () => {
      document.title = before;
    };
  }, [label, detail]);
}
